/**
 * "Disable slot" from the timeline: skip today (cleans the draft, holds
 * the day) then flip the slot's enabled switch in container CONFIG — the
 * one source of truth for "forever" — through the field-level endpoint, so
 * nothing else on the slot list (per-group amounts, lanes, pins) is
 * touched. Re-enabling lives in the editor's Drop slots table.
 * For Media Devoted | Created By Ciro Autiero
 */
import { api } from '@/services/api';

const BASE = '/drop-generator';

interface Envelope<T> {
  data: T;
}

type Json = Record<string, unknown>;

export async function disableSlotRequest(input: {
  countryKey: string;
  containerId: string;
  slotId: string;
}): Promise<Json> {
  await api.post<Envelope<Json>>(`${BASE}/generate/${input.countryKey}/slots/${input.slotId}/skip`);
  const res = await api.patch<Envelope<Json>>(
    `${BASE}/containers/${input.containerId}/slots/${input.slotId}/enabled`,
    { enabled: false },
  );
  return res.data.data;
}
